export default "__VITE_ASSET__BsExUH4g__"